import { makeStyles } from '@material-ui/core/styles';
import formStyles from '../../Screens/GeneralStyles/formStyle';

export default makeStyles(theme => ({
    ...formStyles(theme),
    cancelText: {
        paddingLeft: theme.spacing(2)
    }
}))
